<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head is-small">
      <p class="modal-card-title">{{ title }}</p>
    </header>
    <section class="modal-card-body">
      <b-datepicker v-model="date" inline></b-datepicker>
    </section>
    <footer
      class="modal-card-foot"
      style="display: flex; justify-content: space-between"
    >
      <b-button label="Close" @click="$emit('close')" />
      <div>
        <b-button
          label="Clear"
          type="is-secondary"
          @click="clear"
          :disabled="isSaving"
        />
        <b-button
          label="Set"
          type="is-primary"
          @click="save"
          :disabled="isSaving"
        />
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  props: ['title', 'handler'],
  data: () => ({ date: new Date(), isSaving: false }),
  methods: {
    async clear() {
      this.isSaving = true;
      await this.handler(null);
      this.$emit('close');
    },
    async save() {
      this.isSaving = true;
      await this.handler(this.date);
      this.$emit('close');
    },
  },
};
</script>
